//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ASCVD_info'

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/ASCVD_info.vue